import React from 'react';
import { variant, compose, space, color, border, height } from 'styled-system';
import styled from 'styled-components';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, radius, color as color$1 } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { forwardRef } from '../../system/forwardRef.es.js';
import Button from '../Button/Button.es.js';
import { useModalContext } from './ModalContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const styles = variant({
  prop: "size",
  variants: {
    sm: { px: [null, "md", "lg"], py: [null, "md", "md"] },
    md: { px: [null, "md", "xxl"], py: [null, "md", "lg"] },
    lg: { px: [null, "md", "xxl"], py: [null, "md", "lg"] }
  }
});
const ModalContinueButton = forwardRef((_a, ref) => {
  var _b = _a, { kind = "solid", variant: variant2 = "primary", size = "md" } = _b, props = __objRest(_b, ["kind", "variant", "size"]);
  return /* @__PURE__ */ React.createElement(Button, __spreadValues({
    ref,
    kind,
    variant: variant2,
    size
  }, props));
});
ModalContinueButton.displayName = "Modal.ContinueButton";
const ModalCancelButton = forwardRef((_c, ref) => {
  var _d = _c, { kind = "solid", variant: variant2 = "subtle", size = "md" } = _d, props = __objRest(_d, ["kind", "variant", "size"]);
  return /* @__PURE__ */ React.createElement(Button, __spreadValues({
    ref,
    kind,
    variant: variant2,
    size
  }, props));
});
ModalCancelButton.displayName = "Modal.CancelButton";
const StyledModalFooter = styled("footer")`
    display: flex;
    flex: 0 1 auto;
    justify-content: flex-end;
    min-height: min-content;
    background-color: ${themeMode({
  dark: color$1("neutral.900"),
  light: color$1("neutral.0")
})};
    border-bottom-left-radius: ${radius("base")};
    border-bottom-right-radius: ${radius("base")};
    ${styles};
    ${compose(space, color, border, height)};
`;
const ModalFooter = forwardRef((_e, ref) => {
  var _f = _e, { children } = _f, props = __objRest(_f, ["children"]);
  const { size } = useModalContext();
  return /* @__PURE__ */ React.createElement(StyledModalFooter, __spreadValues({
    ref,
    size
  }, props), children);
});
ModalFooter.displayName = "Modal.Footer";

export { ModalCancelButton, ModalContinueButton, ModalFooter };
//# sourceMappingURL=ModalFooter.es.js.map
